import { put, takeEvery } from 'redux-saga/effects';
import { SAVE_GROUP, SAVE_GROUP_DATA, DELETE_GROUP } from '../../constants';
import { saveGroupData, getGroup, getGroupLi } from '../../actions';
import axios from 'axios';
import dlCommon from '../../dlCommon';


function* sgSaveItem(action) {
    const itemId = action.payload.itemId;
    const item = action.payload.item;
    let url;
    
    if (itemId==='') {
        url = dlCommon.apiUrlGet('dl-group');
        let newItemId = yield axios.post(url, item).then(res => res.data);
        yield put(saveGroupData(newItemId));        
    } else {
        url = dlCommon.apiUrlGet('dl-group', itemId);
        yield axios.put(url, item);        
        yield put(saveGroupData(itemId));        
    }
}

function* sgSaveItemData(action) {
    const itemId = action.payload;
    yield put(getGroup(itemId));
}

function* sgDeleteItem(action) {
    const itemId = action.payload;
    const url = dlCommon.apiUrlGet('dl-group', itemId);
    yield axios.delete(url);       
    yield put(getGroupLi());
}


export function* actWatchAdmDlGroup() {
    yield takeEvery(SAVE_GROUP, sgSaveItem);
    yield takeEvery(SAVE_GROUP_DATA, sgSaveItemData);
    yield takeEvery(DELETE_GROUP, sgDeleteItem);
}

